import React, { useMemo, useState } from 'react';
import { getCoreRowModel } from '@tanstack/react-table';
import { Paper } from '@mui/material';

// Hooks and services
import { addPermissionToPolicy, removePermissionFromPolicy } from '../../../../services/policy.service';
import { exportPermissions, getPermissions } from '../../../../services/permission.service';
import { useNotifyMessage } from '../../../../hooks/useNotifyMessage';
import makePolicyPermissionColumn from './makePolicyPermissionColumn';

// Types
import { Policy } from '../../../../types/Policy';

// Common
import { Table, useStandardTable as useTable } from '../../../common/table';

// Components
import SearchBar from '../../../common/SearchBar/SearchBar';

export default function PolicyPermissions(props: { policy: Policy; setPolicy: (policy: Policy) => void }) {
  const [paramFilter, setParamFilter] = useState<any>({});
  const { notifyMessage } = useNotifyMessage();
  const handleChange = async (event, permissionId) => {
    // add the permission when the target is checked
    if (event.target.checked) {
      const response = await addPermissionToPolicy(props.policy.id, permissionId);

      if (response.status === 200) {
        props.setPolicy(response.data);
        notifyMessage('Permission added to policy', 'success');
      } else if (response.status === 400) {
        notifyMessage(response.data.toString(), 'error');
      } else {
        notifyMessage('FAILED to add permission to policy', 'error');
      }

      return;
    }

    //  remove the policy when the target is un checked
    const response = await removePermissionFromPolicy(props.policy.id, permissionId);

    if (response.status === 200) {
      props.setPolicy(response.data);
      notifyMessage('Permission removed from policy', 'success');

      return;
    }

    notifyMessage('FAILED to remove permission from policy', 'error');
  };

  const columns = useMemo(() => makePolicyPermissionColumn(props.policy, handleChange), [props.policy]);

  const table = useTable<any>({
    columns,
    accessKey: 'id',
    fetchAsync: getPermissions,
    exportAsync: exportPermissions,
    params: paramFilter,
    serverSide: true,
  });

  const onSearchChange = (filters: any) => {
    setParamFilter({
      filters: filters,
    });
  };

  return (
    <>
      <h2>Permissions</h2>
      <React.Fragment>
        <SearchBar onSearch={onSearchChange} columns={columns} allowSearchAll={true} />
        <Paper>
          <Table {...table} showSearchBar={false} showColumnToggler={false} showAction={true} getCoreRowModel={getCoreRowModel()} />
        </Paper>
      </React.Fragment>
    </>
  );
}
